import http from '../common/http';

export default {
  getAll() {
    return http.get('/Contacts');
  },
  get(id) {
    return http.get('/Contacts/contact/' + id);
  }
};
